import { ReactNode } from 'react';
import styles from './index.module.sass';
import trashSvg from '@@/offer/images/trash.svg';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';

export const TopBar = ({
  totalCount,
  selectedCount,
  deleteSelected,
  selectAll,
}: IArgs) => {

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <b>{declineWord(totalCount, ['сделок', 'сделка', 'сделки'])}</b>
        {selectedCount} выбрано
      </div>
      <div className={styles.actionsBar}>
        <Button
          label={
            <span className={styles.delete}>
              <img src={trashSvg} className={styles.icon} /> удалить выбранные
            </span>
          }
          onClick={deleteSelected}
        />
        <Button
          label={<span className={styles.accept}>выбрать все</span>}
          onClick={selectAll}
        />
      </div>
    </div>
  );
};

function Button({ onClick, label }: { onClick: () => void; label: ReactNode }) {
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      className={styles.button}
    >
      {label}
    </a>
  );
}

interface IArgs {
  totalCount: number;
  selectedCount: number;
  deleteSelected: () => void;
  selectAll: () => void;
}
